var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3651_133810)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 2.5C9.11594 2.5 8.2681 2.85119 7.64298 3.47631C7.01786 4.10143 6.66667 4.94928 6.66667 5.83333C6.66667 6.71739 7.01786 7.56523 7.64298 8.19036C8.2681 8.81548 9.11594 9.16667 10 9.16667C10.8841 9.16667 11.7319 8.81548 12.357 8.19036C12.9821 7.56523 13.3333 6.71739 13.3333 5.83333C13.3333 4.94928 12.9821 4.10143 12.357 3.47631C11.7319 2.85119 10.8841 2.5 10 2.5ZM15 10C12.25 10 10 12.25 10 15C10 17.75 12.25 20 15 20C17.75 20 20 17.75 20 15C20 12.25 17.75 10 15 10ZM9.20898 11.7057C6.57565 11.9241 2.5 13.1633 2.5 15.4167V17.5H8.82324C8.50991 16.7275 8.33333 15.885 8.33333 15C8.33333 13.8 8.65398 12.6782 9.20898 11.7057ZM15 12.5C15.46 12.5 15.8333 12.8733 15.8333 13.3333V14.1667H16.6667C17.1267 14.1667 17.5 14.54 17.5 15C17.5 15.46 17.1267 15.8333 16.6667 15.8333H15.8333V16.6667C15.8333 17.1267 15.46 17.5 15 17.5C14.54 17.5 14.1667 17.1267 14.1667 16.6667V15.8333H13.3333C12.8733 15.8333 12.5 15.46 12.5 15C12.5 14.54 12.8733 14.1667 13.3333 14.1667H14.1667V13.3333C14.1667 12.8733 14.54 12.5 15 12.5Z",
    fill: "black",
    fillOpacity: 0.54
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3651_133810"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvite);
export default __webpack_public_path__ + "static/media/Invite.668f62c073317749b327fa77c464ff9f.svg";
export { ForwardRef as ReactComponent };